import Button from '@platform-ui-common/components/Button/index.js';
import FormContainer from '@platform-ui-common/components/FormContainer/index.js';
import Markdown from '@platform-ui-common/components/Markdown/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import useApplication from '@platform-ui-common/hooks/contexts/useApplication.js';
import useProgram from '@platform-ui-common/hooks/contexts/useProgram.js';
import useCustomPageTitle from '@platform-ui-common/hooks/useCustomPageTitle.js';
import { usePushApplicationPage } from '@platform-ui/application/hooks/index.js';
import useApplicationConfig from '@platform-ui/application/hooks/useApplicationConfig.js';
import ApplicantRoutes from '@platform-ui/application/utils/ApplicantRoutes.js';
import { getApplicantSections } from '@platform-ui/utilities/application/config.js';
import { getFirstEnabledQuestionGroupPage } from '@platform-ui/utilities/application/question.js';
import { IKImage } from 'imagekitio-react';
import { Redirect, useParams } from 'react-router';

export default function QuestionGroupOverview(): JSX.Element {
  const { groupKey } = useParams<{ groupKey: string }>();
  const application = useApplication();
  const config = useApplicationConfig();
  const program = useProgram();
  const pushApplicationPage = usePushApplicationPage();
  const currentGroup = getApplicantSections(config)
    .flatMap(({ questionGroups }) => questionGroups)
    .find((group) => group.key === groupKey);
  if (!currentGroup) return <Redirect to={ApplicantRoutes.APPLICATION_PORTAL} />;

  const {
    overview: { title, description },
  } = currentGroup;

  useCustomPageTitle(title);

  return (
    <FormContainer
      buttons={<Button type="submit">Continue</Button>}
      onSubmit={(): void =>
        pushApplicationPage(getFirstEnabledQuestionGroupPage(currentGroup, application.answers))
      }
    >
      <IKImage
        className="w-full mx-7 md:w-3/5 md:mx-0 lg:w-2/5 pb-10"
        src={program.heroImage}
        alt={`${program.name} logo`}
        urlEndpoint="https://ik.imagekit.io/bybeam/"
        transformation={[{ height: '80', dpr: `${window.devicePixelRatio}` }]}
      />
      <div className="w-field max-w-full md:w-1/2 mx-8">
        <Typography alignment="center" variant="h1">
          {title}
        </Typography>
        <br />
        <Markdown variant="largeBody" alignment="center">
          {description}
        </Markdown>
      </div>
    </FormContainer>
  );
}
